// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import services from './services/axios'
import store from './store';
import utils from './utils';
import './icons' // icon


import useElementUI from './elementUI'
import 'element-ui/lib/theme-chalk/index.css';
useElementUI.useElementUI()
import useVant from './vant';
import 'vant/lib/index.css';
useVant.useVant()


import moment from 'moment';
Vue.prototype.$moment = moment

Vue.prototype.$utils = utils;
Vue.prototype.$axios = services;
Vue.prototype.$screenWidth = window.innerWidth

Vue.config.productionTip = false



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js